import React from "react";
import { Trash2, X, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Sticky floating bar that appears when items are selected.
 * Used on both the Clients list and the Task list.
 */
export default function BulkActionsBar({
  count,
  onClear,
  onDelete,
  submitting,
  testId,
  deleteTestId,
  entityLabel = "item",
}) {
  if (!count) return null;
  const plural = count === 1 ? entityLabel : `${entityLabel}s`;
  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-30 ab-shadow-sm rounded-full border border-[#0F172A]/10 bg-[#0F172A] text-white px-3 py-1.5 flex items-center gap-2"
      data-testid={testId}
      role="region"
      aria-label="Bulk actions"
    >
      <button
        type="button"
        onClick={onClear}
        className="h-7 w-7 inline-flex items-center justify-center rounded-full hover:bg-white/10"
        title="Clear selection"
        aria-label="Clear selection"
      >
        <X className="h-3.5 w-3.5" />
      </button>
      <span className="text-xs font-medium tabular-nums px-1">
        {count} {plural} selected
      </span>
      <button
        type="button"
        onClick={onDelete}
        disabled={submitting}
        data-testid={deleteTestId}
        className={cn(
          "inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full text-xs font-medium",
          "bg-[#DC2626] text-white hover:bg-[#B91C1C] disabled:opacity-60"
        )}
      >
        {submitting ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <Trash2 className="h-3.5 w-3.5" />
        )}
        Delete Selected
      </button>
    </div>
  );
}
